
/*
    Permissions Enum Like
*/



// Available permission Type in immutable form corresponding to CRUD operation

export const PermissionType = Object.freeze({
    CREATE: "create",
    READ: "read",
    UPDATE: "update",
    DELETE: "delete"
});

// Available permissions in immutable form

export const Permissions = Object.freeze({
    PROFILE: {name: "profile", title: "User Profile"},
    USER_GROUP: {name: "userGroup", title: "User Group Management"},
    REPORTS: {name: "reports", title: "Report Management"},
    DOCUMENTS: {name: "documents", title: "User Document"},
    SAVED_CARDS: {name: "savedCards", title: "User Saved Cards"},
    BANK_ACCOUNTS: {name: "bankAccounts", title: "User Bank Account"},
    ACCOUNTS: {name: "accounts", title: "Trading Account"},
    ACCOUNT_META: {name: "accountMeta", title: "Account Meta"},
    PENDING_KYC: {name: "pendingKYC", title: "Pending KYC"},
    ACTIONS: {name: "actions", title: "Actions Preview"},
    INSTRUMENTS: {name: "instruments", title: "Instruments"},
    NUBANS: {name: "nubans", title: "Reserved Account"},
    ORDERS: {name: "orders", title: "Order Management"},
    TRANSACTIONS: {name: "transactions", title: "Wallet Transactions"},
    HOLDINGS: {name: "holdings", title: "Holdings Management"},
    THEMES: {name: "themes", title: "Themes Management"},
    EXCHANGE_RATES: {name: "exchangeRates", title: "Exchange Rates"},
    REFERRALS: {name: "referrals", title: "Referrals"},
    CARDS: {name: "cards", title: "cards"},
    MIGRATIONS: {name: "migrations", title: "User Migrations"},
    PENDING_BVNS: {name: "pendingBvns", title: "Pending BVNS"},
    PAYMENTS: {name: "payments", title: "Deposit and Withdrawal"},
    BANKS: {name: "banks", title: "Bank Management"},
    SETTINGS: {name: "settings", title: "Settings"},
    SUBSCRIPTIONS: {name: "subscriptions", title: "Subscription Management"},
    GIFT_CARDS: {name: "giftCards", title: "Gift Card Management"},
    SAFE_LOCK: {name: "safeLocks", title: "Safe Lock Management"},
    SOCIAL: {name: "social", title: "Social Management"},
    MAINTENANCE_FEE: {name: "maintenanceFee", title: "Maintenance Fee"},
    GEMS: {name: "gems", title: "Gems"},
    STALLED_TRANSACTIONS: {name: "stalledTransactions", title: "Stalled Transactions"},
    CAMPAIGNS: {name: "campaigns", title: "Campaigns"},
    SECURITY_QUESTIONS: {name: "securityQuestions", title: "Securityquestions"},
});
